<template>
  <div class="container">
    <div class="loadEffect">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <span class="tips">免费领取中</span>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    // 饿了么
    fetchEleme() {
      location.href = 'https://s.click.ele.me/gCKpbnu';
    },
    // 美团外卖
    fetchMtwm() {
      location.href = 'https://click.meituan.com/t?t=1&c=1&p=OWMpZ-uzIFOVe6JyOONs3dXuqV0qcAf-r-KCvHdXiNcVucFhoPr6Y2B7CqCX7gVgdRqNMEWVUcDtP1wPOsj491ga0wUMVdVuDDDlucLNN8UkRz1j0a99vKDzECIVSgFC_e89daPS-Uv6rh3fGr_V9EcfklOPis0UuKiUd955azLZGgc3ISktZGuOvi02Mx7IBAA4wmw-nquJSSgbvONu2bJZz4-xQlSooOr0upq14eT-Vb25_nlaH_5iiAAQjBwxcN_xn0HpWbTCTeVhSgL5UqLvaRkTQBicGn-9hZEnj4Ufr1eSQCp1gQevIIQNROFJGXRe8G_-5mqGHLUtjpcnLyr4McDrQhQud-nEwuXUuuxEh_TNKG_VXNY68O64wF2wk2ag4FcEj-yU9OTUiOExCItZf7Inj-oZoKO_PP6Z4c6Cm8j9moUT_I96j_E7UuENhqIw066crQtKXBRbU4PZ0DB17pMl7ggcV22TmDGvZsUxDxivLmXQJcLqDjbWC0dKAe0I3rbC29tw96trvNsNSyEQ_saaw2UGCefbVNi3VuO6tJ3DYr4MomNT9e-K8MU-ZycSggDpUlOUUJjnRDkyy0rjS3zIJce3AGsIRNnhPMcI7iQf6QPsiiLxP3mMZlaoqikOPw_vfm1OPIkNPTm11c3X7D2KnckJ2opNSTjA1DGyRgoMtPYJiEJtRX3L6IN2Yg2FvqF1eW7X0fH-P9dvPw';
    }
  },
  created() {
    document.title = '领取中 · · ·';
  },
  mounted() {
    const platform = this.$route.params.platform;
    console.log(platform);
    if ('eleme' == platform) {
      this.fetchEleme();
    } else if ('mtwm' == platform) {
      this.fetchMtwm();
    } else if ('jingdong' == platform) {
      this.$router.push('/jingdong');
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;

  .loadEffect{
      width: 100px;
      height: 100px;
      position: relative;
      margin: 0 auto;
  }
  .loadEffect span{
      display: inline-block;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: #666;
      position: absolute;
      -webkit-animation: load 1.04s ease infinite;
  }
  @-webkit-keyframes load{
      0%{
          opacity: 1;
      }
      100%{
          opacity: 0.2;
      }
  }
  .loadEffect span:nth-child(1){
      left: 0;
      top: 50%;
      margin-top:-8px;
      -webkit-animation-delay:0.13s;
  }
  .loadEffect span:nth-child(2){
      left: 14px;
      top: 14px;
      -webkit-animation-delay:0.26s;
  }
  .loadEffect span:nth-child(3){
      left: 50%;
      top: 0;
      margin-left: -8px;
      -webkit-animation-delay:0.39s;
  }
  .loadEffect span:nth-child(4){
      top: 14px;
      right:14px;
      -webkit-animation-delay:0.52s;
  }
  .loadEffect span:nth-child(5){
      right: 0;
      top: 50%;
      margin-top:-8px;
      -webkit-animation-delay:0.65s;
  }
  .loadEffect span:nth-child(6){
      right: 14px;
      bottom:14px;
      -webkit-animation-delay:0.78s;
  }
  .loadEffect span:nth-child(7){
      bottom: 0;
      left: 50%;
      margin-left: -8px;
      -webkit-animation-delay:0.91s;
  }
  .loadEffect span:nth-child(8){
      bottom: 14px;
      left: 14px;
      -webkit-animation-delay:1.04s;
  }

  .tips {
    position: absolute;
    top: calc(50wh - 6px);
    width: 100vw;
    text-align: center;
    font-size: 12px;
    line-height: 12px;
    color: rgba(0, 0, 0, 0.5);
    // color: #ee786e;
  }
}
</style>
